import { IInsightDialog } from '@jumpstart/core';
import { nanoid } from 'nanoid';
import { InsightNode } from './widgets/DialogTreeVisual';

export class DialogUtils {

  /**
   * For any node, grab its parent
   */
  public static parent(node: InsightNode): IInsightDialog {
    const traverse = (_node: InsightNode): InsightNode => {
      if (_node.parent) {
        return traverse(_node.parent);
      } else {
        return _node;
      }
    }
    return traverse(node).data;
  }

  /**
   * When supplying new responses, we want to make sure the ids are unique
   */
  public static handleNewIds(parent: IInsightDialog, responses?: {[id: string]: IInsightDialog}): {[id: string]: IInsightDialog} {
    if (!responses) {
      return {}
    }
    const existing = this.flatten(parent);
    const traverse = (dialog: IInsightDialog) => {
      if (existing.findIndex(d => d.id === dialog.id) > -1) {
        dialog.id = nanoid(10);
      }
      if (dialog.responses) {
        Object.keys(dialog.responses).forEach((key: string) => {
          traverse((dialog as any).responses[key]);
        });
      }
    }
    Object.keys(responses).forEach((key: string) => {
      traverse(responses[key]);
    });
    return responses;
  };

  /**
   * Take any node and flatten its responses into a array of dialogs
   */
  public static flatten(node: IInsightDialog) {
    const nodes: IInsightDialog[] = [];
    const traverse = (currentNode: IInsightDialog, answer?: string | null, parentNode?: IInsightDialog) => {
      nodes.push(currentNode);
      if (currentNode.responses) {
        Object.keys(currentNode.responses)
          .forEach((_answer: string) => traverse((currentNode.responses as any)[_answer], _answer, currentNode));
      }
    };
    traverse(node);
    return nodes;
  };
}
